import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ROUTE_DASHBOARD, ROUTE_GOVCRM_CONTACTS } from '../../constants';
import Suspense from '../../services/lazyLoad/Suspense';

const Contacts = React.lazy(() => import('./Contacts'));

export default function GovCrm() {
  // Org-level CRM gate driven by the Salesforce GovConCrmAccess__c flag. The flag
  // is resolved server-side and delivered via organization.getOrganizationInfo.
  const crmAccessEnabled = useSelector((state) => state.orgSettings.crmAccessEnabled === true);

  if (!crmAccessEnabled) {
    return <Redirect to={ROUTE_DASHBOARD.path} />;
  }

  return (
    <Suspense>
      <Switch>
        <Route exact path={ROUTE_GOVCRM_CONTACTS.path}>
          <Contacts />
        </Route>
        <Redirect exact path="/*" to={ROUTE_GOVCRM_CONTACTS.path} />
      </Switch>
    </Suspense>
  );
}
